import React, { useState } from 'react';
import { FormattedNumber } from 'react-intl';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import { getTemplateString } from 'common/helpers/string';
import PaymentContainer from 'components/PaymentContainer/PaymentContainer';
import PageLink from 'components/PageLink/PageLink';
import styles from './OfferDirectPaymentPageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';
import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const OfferDirectPaymentPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;

  const discountRate = getTemplateString(PageData.SettlementDiscountLabel);
  const [settlementDirectPaymentEventTracked, setSettlementDirectPaymentEventTracked] = useState<boolean>(false);

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

  

  var tagManagerArgs: any;
  useEffect(() => {
    if (settlementDirectPaymentEventTracked === false) {
      
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Settlement Single Payment',
          checkout_step_number: '1',
          is_secured_user: LayoutModel?.IsLoggedInUserSecured,
          ...(LayoutModel?.IsLoggedInUserSecured && {secured_case_status : LayoutModel?.SecuredCaseStatus} ) 
        }
      }
      TagManager.dataLayer(tagManagerArgs);
      setSettlementDirectPaymentEventTracked(true);
      
    }
  }, [Model]);
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <main className="CreateRepaymentPlan u-paddingTz">
          <section className="CreateRepaymentPlan__section">
            <ChangePlanHeader Headingtext={PageData.PaymentSummaryLabel} />
          </section>
          <section className="CreateRepaymentPlan__section">
            <div className="settlementAmount">
              <div className="settlementAmount__wrapper">
                <div className="settlementAmount__heading">
                  <span className="settlementAmount__label settlementAmount__label--large">
                    {PageData.DiscountedDebtBalanceLabel}
                  </span>
                  <span className="settlementAmount__amount">
                    {Model?.FormattedCurrencyDiscountedDebtBalance}
                  </span>
                </div>
                <div className="settlementAmount__row">
                  <div className="settlementAmount__column">
                    <span className="settlementAmount__label">
                      {PageData.DebtBalanceLabel}
                    </span>
                    <span className="settlementAmount__balance">
                      {Model?.FormattedCurrencyDebtBalance}
                    </span>
                  </div>
                  <div className="settlementAmount__column">
                    <span className="settlementAmount__label">
                      {discountRate &&
                        discountRate({
                          DiscountRate: Model?.DiscountRate,
                        })}
                    </span>
                    <span className="settlementAmount__discount">
                      {Model?.FormattedCurrencySettlementDiscount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="CreateRepaymentPlan__section">
            <div
              id="@Model.AdyenForm.FormRootNodeId"
              className="adyen-form-root"
            >
              <PaymentContainer Model={Model} PageData={PageData} />
              {Model.AdyenForm.IsPaymentError && (
                <div className="adyen-payment-error">
                  {PageData.AdyenPaymentError}
                </div>
              )}
            </div>
          </section>
          <section className="CreateRepaymentPlan__section">
            <div className="CreateRepaymentPlan__ctaWrapper CreateRepaymentPlan__ctaWrapper--centerAlign">
              <PageLink
                url={Model.OfferSettlementPage.Uri}
                text={PageData.BackButtonLabel}
                className="Button Button--gray CreateRepaymentPlan__cancelBtn"
              />
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default OfferDirectPaymentPageData;
